import { globalStores } from '@/editor/stores';
import WindowEntity from '@/editor/entities/windowEntity';
import { EEntityType, ESceneMode } from '@/editor/types';

export class WindowManager {
  private _list: WindowEntity[] = [];
  private _visible: boolean;

  constructor() {
    this._visible = true;
  }

  get entities() {
    return this._list;
  }

  private getDataList() {
    const isScene3d = globalStores.sceneMode === ESceneMode.scene3d;
    const windowHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.DoorWindow);

    const scene3dViewChangeHiddenWallIds = isScene3d
      ? globalStores.visibilityStore.get3dViewChangeHiddenWallIds()
      : new Set();

    return globalStores.modelStore
      .getWindowDatas()
      .filter(
        (data) =>
          !windowHiddenIds.has(data.id) && !scene3dViewChangeHiddenWallIds.has(data.relativeWallInfo.relativeWallId)
      );
  }

  getDoorWindowEntity(id: string) {
    const doorWindow = this._list.find((dw) => dw.id === id);
    return doorWindow;
  }

  update() {
    const newWindowDatas = this.getDataList();
    const newWindowDataMap = new Map(newWindowDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      const newWindowData = newWindowDataMap.get(entity.id);
      if (newWindowData) {
        entity.update({ extendedWindowData: newWindowData });
      } else {
        this.deleteEntity(i);
      }

      newWindowDataMap.delete(entity.id);
    }

    for (const newWindowData of newWindowDataMap.values()) {
      const windowEntity = new WindowEntity(newWindowData);
      this.addEntity(windowEntity);
    }
  }

  forceUpdate() {
    this._list.forEach((entity) => entity.update({ forceUpdate: true }));
  }

  getEntity(entityId: string) {
    return this._list.find((entity) => entity.id === entityId);
  }

  updateEntity(id: string) {
    const entity = this.getEntity(id);
    const windowData = globalStores.modelStore.getWindowData(id);

    if (entity) {
      if (windowData) {
        entity.update({ extendedWindowData: windowData });
      } else {
        this.deleteEntityById(id);
      }
    } else {
      if (windowData) {
        this.addEntity(new WindowEntity(windowData));
      }
    }
  }

  deleteEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  deleteEntityById(entityId: string) {
    const entity = this.getEntity(entityId);
    if (entity) {
      entity.dispose();
      this._list.splice(this._list.indexOf(entity), 1);
    }
  }

  addEntity(entity: WindowEntity) {
    this._list.push(entity);
  }
}
